import React from 'react';

export default function Header({ lang, toggleLang }) {
  return (
    <header className="sticky top-0 z-50 bg-black border-b-4 border-amber-400 shadow-[0_4px_0_0_#ffffff]">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
        <div className="text-amber-400 font-black text-xl tracking-tighter uppercase">
          {lang === 'en' ? 'Beer Pass' : 'Pase Cervecero'}
        </div>
        
        <button 
          onClick={toggleLang}
          className="flex items-center gap-2 font-bold text-lg bg-white text-black px-3 py-1 border-2 border-transparent hover:border-amber-400 transition-colors"
        >
          <span className={lang === 'en' ? 'opacity-100' : 'opacity-40'}>EN</span>
          <span>/</span>
          <span className={lang === 'es' ? 'opacity-100' : 'opacity-40'}>ES</span>
        </button>
      </div>
    </header>
  );
}